import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Ip800 } from 'src/app/models/ip800';
import { CustomerTableModel } from 'src/app/models/table-models/customer-table';
import { Ip800Service } from 'src/app/services/ip800.service';
import { ReportService } from 'src/app/services/report.service';
import { PosIp800ModalComponent } from 'src/app/shared/pos-ip800-modal/pos-ip800-modal.component';
import { ModalDialogType } from '../constants';
import { PosConfirmationService } from './pos-confirmation.service';

@Injectable({
  providedIn: 'root'
})
export class PosIp800ModalService {

  private modalRef?: BsModalRef;
  constructor(private modalService: BsModalService, private readonly ip800Service: Ip800Service, private readonly confirmService: PosConfirmationService, private readonly reportService: ReportService) { }

  show(customer: CustomerTableModel, confirmAction: (value: Blob) => any): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      this.modalRef = this.modalService.show(PosIp800ModalComponent,
        {
          ignoreBackdropClick: true
        })

      this.modalRef.setClass(`modal-dialog modal-md ${ModalDialogType.PRIMARY}`)
      this.modalRef.content.customer = customer;
      this.modalRef.content.confirmAction = confirmAction;
      await this.modalRef.content.load();
      resolve(true)
    });
  }

  async showAsync(customer: CustomerTableModel): Promise<Blob> {
    const ip800List = (await this.ip800Service.readIP800Requests(customer.code).toPromise()).response;
    if (ip800List.totalElements > 0) {
      const result = await this.confirmService.showAsync("Solicitud IP800", "Ya existe una solicitud IP800, ¿Desea imprimirlo en su lugar?", ModalDialogType.SUCCESS);
      if (result) {
        return this.confirm(ip800List.content[0]);
      }
    }
    return await this.showModal(customer);
  }

  private async showModal(customer: CustomerTableModel) {
    this.modalRef = this.modalService.show(PosIp800ModalComponent, {
      ignoreBackdropClick: true,
      animated: true,
      initialState: {
        customer: customer,
      }
    });

    this.modalRef.setClass(`modal-dialog modal-md ${ModalDialogType.PRIMARY}`);
    await this.modalRef.content.loadForms();
    return this.modalRef.content!.confirmActionEmitter.toPromise();
  }

  private async confirm(ip800: Ip800) {
    return this.reportService.ip800RequestPdf(ip800.code).toPromise();
  }
}
